import React from 'react';
import cn from 'classnames';

function LoadingSpinner({ className }) {
  return (
    <div className={cn('text-center', className)}>
      <i className="fas fa-spinner m-3 fa-spin" style={{ fontSize: '30px' }} aria-hidden="true" />
      <span className='sr-only'>Loading...</span>
    </div>
  )
}

export default LoadingSpinner